export default "__VITE_ASSET__36c505ca__"